import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

const selectors = {
  sliderContainer: '[data-slider-container]',
};

const sectionType = 'featured-articles';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      const container = this.container;

      const slider = container.querySelector(selectors.sliderContainer);
      if (!slider) return;

      // eslint-disable-next-line no-unused-vars
      const flickity = new Flickity(slider, {
        // options
        prevNextButtons: false,
        pageDots: true,
        cellAlign: 'left',
        watchCSS: true,
        contain: true,
      });
    },
  });
